import { Campaign } from "../../types/sponsorships/campaigns";
import { textToTitleCase } from "../../utils/helpers";

export const getCategory = (campaign: Campaign): string => {
    const firstNiche = campaign.niche_names?.[0] ?? campaign.niches?.[0];
    return firstNiche || campaign.strategy_name || "General";
};

export const getTier = (campaign: Campaign): string => {
    const tier = campaign?.requirements?.creator_bucket || "Nano";
    return textToTitleCase(tier);
};

export const getSeatsLabel = (campaign: Campaign): string => {
    const seats = Number(
        (campaign?.requirements?.creator_count?.max ?? 0) ||
        (campaign?.requirements?.creator_count?.min ?? 0) ||
        10
    );
    return `${seats} ${seats === 1 ? "seat" : "seats"}`;
};
